import { SSN_STRING_LENGTH } from "../../../constants";

const insertAt = (str: string, sub: string, pos: number) =>
  `${str.slice(0, pos)}${sub}${str.slice(pos)}`;

export const displaySSN = (value: string) => {
  let stringValue: string;
  try {
    stringValue = value.toString();
    if (!stringValue) throw new Error();
  } catch (e) {
    return "";
  }
  stringValue = stringValue.replace(/[^\d]/g, ""); // replce non-digit chars
  stringValue = insertAt(stringValue, "-", 3); // for display
  stringValue = insertAt(stringValue, "-", 6); // for display
  stringValue = stringValue
    .replace("--", "") // just in case
    .replace(/-$/, ""); // don't add trailing hyphen, breaks backspace
  return stringValue;
};

// The viewModel and API don't include hyphens. Also enforces max length, prior to setting viewModel, avoiding off-by-one error.
export const unDisplaySSN = (value: string) => value.replace(/-/g, "").slice(0, SSN_STRING_LENGTH);
